import React, { useEffect, useState } from "react";
import useHover from "../hooks/useHover";
import collectionStore from "../stores/collectionStore";
import CounterDescription from "./CounterDescription";

const Counter = ({
  icon,
  count,
  hoverDescription,
  onClick,
  name,
  selectedOverviews = [],
}) => {
  const hover = useHover(hoverDescription);

  const { open, saved } = collectionStore();
  const [value, setValue] = useState(0);

  useEffect(() => {
    const obj = {
      open,
      saved,
    };
    const isNumber = typeof count === "number";
    if (isNumber) {
      setValue(count);
    } else {
      if (obj[count[0]][count[1]]) {
        const arrayValue = obj[count[0]][count[1]];
        setValue(arrayValue.length);
      }
    }
  }, [count, open, saved]);
  return (
    <div
      style={{
        cursor: "pointer",
        marginLeft: "10px",
        marginRight: "10px",
        marginTop: "2px",
        padding: selectedOverviews.includes(name) ? "5px" : "6px",
        border: selectedOverviews.includes(name) ? "1px solid white" : null,
        backgroundColor: selectedOverviews.includes(name) ? "#8f8f8f" : null,
        borderRadius: "5px",
      }}
      className="divColumn"
      {...hover.divProps}
      onClick={() => {
        if (onClick) onClick(name);
      }}
    >
      <img src={icon} className="icon25" style={{ width: "25px" }} />
      <div className="textBoldWhite">{value}</div>
      {hover.hoverDescription}
    </div>
  );
};

export default Counter;
